import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {MessageContact} from '../model/message-contact/message-contact';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {Endpoints} from '../../../models/enums/endpoints/endpoints';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) {
  }

  sendMailContact(messageContact: MessageContact): Observable<string> {
    return this.http.post(
      `${environment.backendUrl}${environment.backendUri}/${Endpoints.CONTACT}`, messageContact,
      {responseType: 'text'});
  }
}
